<template>
  <div id="top-error">
    <loading v-if="loadingState" />
    <form v-if="contests.config" id="edit-user-form" autocomplete="qwerqrt">
      <div class="center mb-1 pt-2 pt-5">
        <h5 class="uppercase">
          Inserisci i/il prodotti/o presenti/e nello scontrino :
        </h5>
      </div>
      <div class="col-md-12 col-lg-12 mb-0">
        <div
          v-for="(elem, num) in products"
          :key="num"
          class="row"
          v-on:click="priceMod(num)"
        >
          <div class="col-md-6">
            <div class="group ml-0 mr-0">
              <label class="lable-style" for="product">Prodotto</label>
              <v-select
                @input="selectChange(products)"
                :options="products_contest"
                :key="elem.product"
                v-model="elem.product"
                :clearable="false"
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    :required="!elem.product"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
              </v-select>

              <span class="highlight"></span>
              <span class="bar"></span>
              <div v-if="errProd" class="invalid-feedback-1">
                Devi inserire almeno un prodotto tra quelli in elenco
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="group ml-0 mr-0">
              <label class="lable-style" :for="elem.indexCount">Quantità</label>
              <input
                type="number"
                v-model="elem.quantity"
                :disabled="!contests.config.QNT_MODIFICABILE"
                class="form-control"
                :id="elem.indexCount"
                :name="elem.indexCount"
                data-vv-as="Quantità"
                v-validate="{
                  required: true,
                  is_not: '0',
                  min_value: 1,
                  max_value: contests.config.PRODOTTI_MASSIMO,
                  max: 2,
                }"
                :class="{
                  'is-invalid': errors.has(elem.indexCount),
                  valid: !!elem.quantity,
                  dis: !contests.config.QNT_MODIFICABILE,
                }"
              />
              <span class="highlight"></span>
              <span class="bar"></span>
              <div
                v-if="errors.has(elem.indexCount)"
                class="invalid-feedback-1"
              >
                {{ errors.first(elem.indexCount) }}
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div
              class="group ml-0 mr-0"
              v-if="contests.config.DESTINAZIONE_SCONTO != 'PUNTI'"
            >
              <label class="lable-style" :for="elem.indexCount"
                >Importo unitario</label
              >
              <input
                type="text"
                :disabled="!priceMod1"
                @focus="activateMod(elem.price)"
                @blur="deactivateMod(elem.price)"
                v-model="elem.price"
                v-on:keyup="elem.price = elem.price.replace(',', '.')"
                class="form-control"
                :id="elem.indexCount + 'p'"
                :name="elem.indexCount + 'p'"
                data-vv-as="importo unitario"
                v-validate="{ required: true, is_not: '0', decimal: 2 }"
                :class="{
                  'is-invalid': errors.has(elem.indexCount + 'p'),
                  valid: !!elem.price,
                  dis: !priceMod1,
                }"
              />
              <span class="highlight"></span>
              <span class="bar"></span>
              <div
                v-if="errors.has(elem.indexCount + 'p')"
                class="invalid-feedback-1"
              >
                {{ errors.first(elem.indexCount + "p") }}
              </div>
            </div>
            <div
              class="group ml-0 mr-0"
              v-if="contests.config.DESTINAZIONE_SCONTO == 'PUNTI'"
            >
              <label class="lable-style" :for="elem.indexCount"
                >Punteggio unitario</label
              >
              <input
                type="text"
                :disabled="!priceMod1"
                @focus="activateMod(elem.points)"
                @blur="deactivateMod(elem.points)"
                v-model="elem.points"
                v-on:keyup="elem.points = elem.points.replace(',', '.')"
                class="form-control"
                :id="elem.indexCount + 'p'"
                :name="elem.indexCount + 'p'"
                data-vv-as="importo unitario"
                v-validate="{ required: true, is_not: '0', decimal: 2 }"
                :class="{
                  'is-invalid': errors.has(elem.indexCount + 'p'),
                  valid: !!elem.points,
                  dis: !priceMod1,
                }"
              />
              <span class="highlight"></span>
              <span class="bar"></span>
              <div
                v-if="errors.has(elem.indexCount + 'p')"
                class="invalid-feedback-1"
              >
                {{ errors.first(elem.indexCount + "p") }}
              </div>
            </div>
            <span v-if="num" class="removeProduct pointer" :class="elem.index">
              <font-awesome-icon
                v-on:click="removeProduct(num)"
                icon="trash-alt"
                size="lg"
                style="background: white; margin-right: 11px; margin-top: 25px"
              />
            </span>
          </div>
        </div>
        <div class="row justify-content-center pb-5">
          <div
            v-if="contests.config"
            class="col-md-6 col-lg-6 mb-3 text-left vcenter mt-md-0 mt-3"
          >
            <img
              v-if="!numMaxQnt_prod && !numMax_prod && !numMaxAttempts_prod"
              class="addProduct imageIcons pointer"
              v-on:click="addProduct"
            />
            <span
              v-if="
                !numMaxQnt_prod &&
                !numMax_prod &&
                !maxSelOk &&
                !numMaxAttempts_prod
              "
              v-on:click="addProduct"
              class="fixPointer white"
              ><b>+</b> Aggiungi prodotto</span
            >
            <small
              v-if="showProdError && contests.config.PRODOTTI_MINIMO"
              class="red"
            >
              <br />!Per completare l'inserimento é necessario aver acquistato
              in un unico atto d’acquisto almeno
              {{ contests.config.PRODOTTI_MINIMO }}
              <a v-if="contests.config.PRODOTTI_MINIMO > 1">prodotti</a
              ><a v-else>prodotto</a>
            </small>
            <small
              v-if="showProdError && contests.config.PREZZO_MINIMO > 0"
              class="red"
            >
              <br />!Per completare l'inserimento é necessario aver acquistato
              in un unico atto d’acquisto almeno
              {{ contests.config.PREZZO_MINIMO }} € di
              <a v-if="contests.config.PREZZO_MINIMO > 1">prodotti</a
              ><a v-else>prodotto</a>
            </small>
            <small v-if="numMaxQnt_prod" class="red Bold h5">
              <br />!Per poter registrare la richiesta per questa promozione
              puoi inserire massimo {{ contests.config.PRODOTTI_MASSIMO }}
              <a v-if="contests.config.PRODOTTI_MASSIMO > 1">prodotti</a
              ><a v-else>prodotto</a>
            </small>
            <small v-if="numMax_prod && !numMaxQnt_prod" class="black">
              <br />!Per poter registrare la richiesta per questa promozione
              puoi inserire massimo {{ contests.config.PRODOTTI_MASSIMO }}
              <a v-if="contests.config.PRODOTTI_MASSIMO > 1">prodotti</a
              ><a v-else>prodotto</a>
            </small>
            <small v-if="numMaxAttempts_prod" class="red Bold">
              <br />!Per questa promozione hai diritto a massimo
              {{ maxRegistration }} buoni, attualmente hai usufruito di
              {{ my_registration_in_promo }} buoni, ne hai a disposizione ancora
              {{ maxRegistration - my_registration_in_promo }}
            </small>
          </div>
          <div
            v-if="maxSelOk"
            class="col-md-6 col-lg-6 mb-3 text-left vcenter mt-md-0 mt-3"
          ></div>
          <div
            v-if="contests.config"
            class="col-md-6 col-lg-6 mb-3 text-right pt-2"
          >
            <h5
              v-if="totPrice && contests.config.DESTINAZIONE_SCONTO != 'PUNTI'"
              class="Bold"
              :class="{ 'invalid-feedback-1': priceError }"
            >
              Totale prodotti: {{ totPrice }}€
            </h5>
            <h5
              v-if="totPrice && contests.config.DESTINAZIONE_SCONTO == 'PUNTI'"
              class="Bold"
              :class="{ 'invalid-feedback-1': priceError }"
            >
              Punteggio richiesto: {{ totPrice }}
            </h5>
            <small
              v-if="minPrice_products && contests.config.PREZZO_MINIMO"
              class="red"
            >
              <br />!Per completare la richiesta di rimborso é necessario che la
              somma dei prodotti sia almeno {{ contests.config.PREZZO_MINIMO }}€
            </small>
            <small
              v-if="maxPrice_products && contests.config.PREZZO_MASSIMO"
              class="red"
            >
              <br />!Per completare la richiesta di rimborso é necessario che la
              somma dei prodotti non superi la soglia massima di
              {{ contests.config.PREZZO_MASSIMO }}€
            </small>
            <!--<h5
              v-if="contests.config.TIPO_SCONTO == 'PERCENTUALE' && discount"
              class="Bold"
              :class="{ 'invalid-feedback-1': priceError }"
            >
              Rimborso totale: {{ (totPrice * (discount / 100)).toFixed(2) }}€
            </h5>
            <h5
              v-if="contests.config.TIPO_SCONTO == 'FISSO' && discount"
              class="Bold"
              :class="{ 'invalid-feedback-1': priceError }"
            >
              Rimborso totale: {{ discount }}€
            </h5>-->
          </div>

          <!--<div v-if="priceError" class="col-md-12 col-lg-12 mb-3 text-center invalid-feedback-1">
			sono valide le prove di acquisto con l'acquisto di almeno: 3,00 Euro di prodotti in promozione 
		</div>-->
          <div class="col-md-6 center">
            <button
              v-if="uploadFrontPercentage == 0"
              v-on:click="play()"
              type="button"
              class="btn btn-primary-1 uppercase pl-3 mb-0"
              :style="
                'background: ' +
                contests.config.COLORE_MEDIO_SCURO +
                '!important'
              "
            >
              <a>Registra richiesta di rimborso</a>
            </button>
          </div>
          <div v-if="mobileUpl" class="col-md-6 center mt-2 pt-1 center">
            <b
              v-if="uploadFrontPercentage == 0"
              @click="logout"
              class="hover underline color uppercase pl-3 mb-0"
            >
              Termina ed esegui il logout
            </b>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>


<script>
import { mapGetters, mapState } from "vuex";
import axios from "axios";
import { AUTH_LOGOUT } from "actions/auth";
import { USER_REQUEST } from "actions/user";
import { ACCEPT_REG } from "actions/auth";
import Datepicker from "vuejs-datepicker";
import { it } from "vuejs-datepicker/dist/locale";
import VueTimepicker from "vue2-timepicker";
import "viewerjs/dist/viewer.css";
import "vue-select/dist/vue-select.css";

const moment = require("moment");

export default {
  name: "Play",
  components: {
    Datepicker,
    VueTimepicker,
  },
  props: {
    date_sc: String,
    time_sc: Object,
    price_sc: String,
    priceCent_sc: String,
    number_sc: String,
    immagine_sc: String,
    ocrContent: Array,
    erroriOcr: Object,
  },
  data() {
    return {
      loadingState: "",
      id: "",
      title: "",
      title: "",
      main_image: "",
      main_text: "",
      regulation: "",
      $viewer: "",
      faq: "",
      maxRegistration: 0,
      products_contest: [],
      disabledDates: {
        to: "",
        from: "",
      },
      step1Text: "",
      step2Text: "",
      step3Text: "",
      step4Text: "",
      call_support: "",
      email_support: "",
      award_name: "",
      award_description: "",
      numMaxQnt_prod: false,
      numMax_prod: false,
      numMaxAttempts_prod: false,
      showProdError: false,
      start: "",
      discount: "",
      end: "",
      start_: "",
      numberOcr: false,
      amountOcr: false,
      end_: "",
      products: [
        {
          index: "product" + 0,
          indexCount: "quantity" + 0,
          product: "",
          quantity: 1,
          points: 0,
          countable: 1,
          price: 0.0,
        },
      ],
      token: "",
      quantity: "",
      wrongErr: false,
      priceError: false,
      totPrice: "",
      priceCent: "",
      price: "",
      priceFocused: false,
      invoiceFrontBucket: "",
      message: "",
      invoiceFront: "",
      it: it,
      uploadFrontPercentage: 0,
      award_image: "",
      loadingState: false,
      empty: false,
      notRegister: false,
      specific: "",
      statusOCR: "",
      change: false,
      mobileUpl: false,
      changeSecond: 0,
      award_type_: "",
      award_type: "",
      rebate: "",
      sale_time: "",
      amount: "",
      priceEur: "",
      number: "",
      piva_shop: "",
      shop: "",
      id_image: "",
      zip: "",
      city: "",
      modify: false,
      province: "",
      ocrData: {},
      type: "",
      showProdError: false,
      maxSelOk: false,
      minPrice: "",
      regex: "",
      minPrice_products: false,
      maxPrice_products: false,
      my_registration_in_promo: "",
      discountClients: "",
      pricenew: "",
      errProd: false,
      canCon: false,
      INF: "",
      productIndex: 0,
      reload: false,
      vw: window.innerWidth,
      imageData: {},
      contests: {},
      time: {
        HH: "",
        mm: "",
      },
      priceMod1: false,
    };
  },
  methods: {
    play: function () {
      this.checkAccess();
      var _vue = this;
      this.errProd_check = true;
      this.errProd_check_N = false;
      for (var i = 0; i < this.products.length; i++) {
        if (this.products[i]["product"]) {
          this.errProd_check = false;
        } else this.errProd_check_N = true;
      }
      if (!this.errProd_check_N) {
        this.errProd = false;

        this.loadingState = true;
        this.$track("createMyProd", "START");
        var data = {
          product: this.products,
          promo: this.contests,
          utente: this.profile,
          id_platform: process.env.ID_PLATFORM,
          unique_key_db: process.env.UNIQUE_KEY_DB,
          vector_unique_key_db: process.env.ICODE,
        };
        data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
        axios({
          method: "POST",
          data: { data },
          url: process.env.ROOT_API + "api/createMyProd",
          headers: {
            Authorization: "Bearer " + process.env.AUTH_TOKEN,
            "Content-type": "application/json",
          },
        })
          .then((resp) => {
            this.$track("createMyProd", "SUCCESS");
            this.$track("createMyProd", resp.data);
            resp.data = this.$decryptByAES(resp.data, process.env.CRYPTKEY);
            this.products1 = resp.data;
            this.$validator.validate().then((valid) => {
              if (
                valid &&
                !this.numMaxQnt_prod &&
                !this.numMaxAttempts_prod &&
                this.date_sc &&
                this.price_sc &&
                this.priceCent_sc &&
                this.number_sc &&
                this.immagine_sc &&
                this.ocrContent
              ) {
                var _vue = this;
                var sale_time = this.time_sc.HH + ":" + this.time_sc.mm + ":00";
                var errors = "";
                for (var i in _vue.erroriOcr) {
                  if (_vue.erroriOcr[i].status == "KO") {
                    errors +=
                      '<h4 class="smallText">' +
                      _vue.erroriOcr[i].description +
                      "</h4>";
                  }
                }
                var value = parseInt(this.price) + "" + this.priceCent;
                if (this.softCheck) {
                  errors += '<h4 class="smallText">' + this.softCheck + "</h4>";
                }
                if (
                  valid &&
                  !this.countError &&
                  !this.showProdError &&
                  !this.minPrice_products &&
                  !this.maxPrice_products &&
                  !this.errProd
                ) {
                  var timestamp = moment().valueOf();
                  var data = {
                    profile: this.profile,
                    promo: this.contests,
                    email: this.email,
                    channel:'web',
                    sdate_submit: moment().format("YYYY-MM-DD hh:mm:ss"),
                    ttdate: moment(this.date_sc).format("YYYY-MM-DD"),
                    ttime: sale_time,
                    tvalue: parseInt(this.price_sc) + "." + this.priceCent_sc,
                    tnumber: this.number_sc,
                    rebate: this.discount,
                    piva: this.piva,
                    iban: this.iban,
                    ntk: process.env.AUTH_TOKEN,
                    uid: timestamp + "$" + value,
                    products: this.products1,
                    receipts_uploads: [{ url1: this.immagine_sc }],
                    ocrData: this.ocrContent,
                    INF: this.INF,
                    code: 200,
                    description: errors,
                    id_platform: process.env.ID_PLATFORM,
                    unique_key_db: process.env.UNIQUE_KEY_DB,
                    vector_unique_key_db: process.env.ICODE,
                  };
                  this.$track("Play", data);
                  data = this.$encryptByAES(
                    JSON.stringify(data),
                    process.env.CRYPTKEY
                  );
                  this.loadingState = true;
                  this.$track("Play", "START");

                  axios({
                    data: { data },
                    url: process.env.ROOT_API + "api/play",
                    method: "POST",
                    headers: {
                      Authorization: "Bearer " + process.env.AUTH_TOKEN,
                      "Content-type": "application/json",
                    },
                    withCredentials: false,
                  })
                    .then((resp) => {
                      this.$track("Play", "SUCCESS");
                      this.$track("Play", resp.data);
                      resp.data = this.$decryptByAES(
                        resp.data,
                        process.env.CRYPTKEY
                      );
                      if (resp.data.status_code == 200) {
                        this.showPlay();
                        this.resetForm();
                      } else {
                        if (resp.data.status_code == 112) {
                          this.showError(
                            "Lo scontrino risulta essere giá caricato"
                          );
                        } else {
                          this.showError("Errore. Riprova piú tardi");
                        }
                      }
                    })
                    .catch((err) => {
                      this.loadingState = false;
                      this.$track("Play", "ERROR");
                      err.response.data = this.$decryptByAES(
                        err.response.data,
                        process.env.CRYPTKEY
                      );
                      this.showError("Errore. Riprova piú tardi");
                    });
                } else {
                  var _vue = this;
                  if (this.showProdError) {
                    _vue.$scrollTo("#quantity", 700, { offset: -170 });
                  }
                  if (this.minPrice_products) {
                    _vue.$scrollTo("#quantity", 700, { offset: -170 });
                  }
                  _vue.$scrollTo("#" + this.errors.items[0].field, 700, {
                    offset: -170,
                  });
                }
              } else {
                var _vue = this;
                setTimeout(function () {
                  _vue.$scrollTo("#top-error", 100, { offset: -800 });
                }, 100);
                this.loadingState = false;
              }
            });
          })
          .catch((err) => {
            this.loadingState = false;
            this.$track("createMyProd", "ERROR");
            this.message =
              '<b class="Bold">I/Il prodotto/i inseriti non sono piu` attivi</b>';
            this.UploadError("", this.message);
            err.response.data = this.$decryptByAES(
              err.response.data,
              process.env.CRYPTKEY
            );
          });
      } else {
        this.errProd = true;
      }
    },
    loadProducts: async function () {
      this.loadingState = true;
      this.$track("loadProducts", "START");
      var data = {
        id: this.$route.params.id,
        id_platform: process.env.ID_PLATFORM,
        unique_key_db: process.env.UNIQUE_KEY_DB,
        vector_unique_key_db: process.env.ICODE,
      };
      data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
      await axios({
        method: "POST",
        data: { data },
        url: process.env.ROOT_API + "api/loadProducts",
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          this.$track("loadProducts", "SUECCESS");
          this.$track("loadProducts", [resp.data]);
          var prod = [];
          for (var x in resp.data) {
            var y = [];
            y["key"] = x;
            y["label"] = resp.data[x];
            y["value"] = resp.data[x];
            prod.push(y);
          }
          this.products_contest = resp.data;
          this.loadingState = false;
        })
        .catch((resp) => {
          this.loadingState = false;
          this.$track("loadProducts", "ERROR");
        });
    },
    logout: function () {
      this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push("/login"));
    },
    inited(viewer) {
      var _vue = this;
      this.$viewer = viewer;
      setTimeout(function () {
        _vue.$viewer.zoom(1);
      }, 1000);
    },
    show() {
      var el = this.$refs.inv;
      const viewer = el.$viewer;
      viewer.show();
      viewer.zoomTo(2);
      viewer.move(-1, 0);
    },
    showError(text) {
      this.$swal({
        type: "error",
        title: '<strong class="Bold">Oops...</strong>',
        html: text,
        confirmButtonText: "CHIUDI",
        confirmButton: "closeProductsModal",
        confirmButtonClass: "btn btn-secondary",
        onClose: () => {
          this.loadingState = false;
          this.$router.push(
            "/contest/" +
              this.$route.params.id +
              "/" +
              this.$route.params.piva +
              "/" +
              this.$route.params.cod
          );
        },
      });
    },

    resetForm() {
      var _vue = this;
      this.$validator.pause();
      this.mail = "";
      this.sdate_submit = "";
      this.ttdate = "";
      this.ttime = "";
      this.tvalue = "";
      this.tnumber = "";
      this.user_token = "";
      this.name = "";
      this.company = "";
      this.sname = "";
      this.piva = "";
      this.iban = "";
      this.address = "";
      this.tel = "";
      this.ntk = "";
      this.uid = "";
      this.receipts = "";
      this.ocrData = "";
      this.products = "";
      this.loadingState = false;
      setTimeout(function () {
        _vue.checkProducts(1);
      }, 200);

      // CLEAR VALIDATOR AFTER REMOVE ALL VALUES
      this.$nextTick(() => {
        this.$validator.reset();
        this.$validator.errors.clear();
        this.$validator.resume();
      });
    },
    addProduct() {
      this.productIndex = this.productIndex + 1;
      this.$track("addProduct", "Siamo al prodotto: " + this.productIndex);
      this.$track(
        "addProduct",
        "Il massimo dei prodotti per questa promo è: " +
          this.contests.config.PRODOTTI_MASSIMO
      );
      if (this.productIndex >= this.contests.config.PRODOTTI_MASSIMO - 1) {
        this.numMax_prod = true;
      } else {
        this.numMax_prod = false;
      }
      this.products.push({
        index: "product" + this.productIndex,
        indexCount: "quantity" + this.productIndex,
        product: "",
        quantity: 1,
        points: 0,
        countable: 1,
        price: 0,
      });
    },
    removeProduct(elem) {
      var _vue = this;
      this.productIndex = this.productIndex - 1;
      if (this.productIndex >= this.contests.config.PRODOTTI_MASSIMO - 1) {
        this.numMax_prod = true;
      } else {
        this.numMax_prod = false;
      }
      var index = this.products.indexOf(elem);
      this.products.splice(elem, 1);
      _vue.calcTotPrice();
    },
    checkProducts: function (param) {
      var products = this.products;
      var count = 0;
      this.$track("checkProducts", products);
      this.$track(
        "checkProducts",
        "IL PREZZO MINIMO : " + this.contests.config.PREZZO_MINIMO
      );
      this.$track(
        "checkProducts",
        "LA QUANTITA MINIMA DI PRODOTTI : " +
          this.contests.config.PRODOTTI_MINIMO
      );
      this.$track("checkProducts", this.contests.config);
      if (this.contests.config.PREZZO_MINIMO > 0) {
        this.showProdError = false;
      } else if (this.contests.config.PRODOTTI_MINIMO) {
        if (param) {
          this.showProdError = false;
          this.$track(
            "checkProducts",
            "Non è da considerarsi un prezzo minimo"
          );
        } else {
          for (var i in products) {
            this.$track("checkProducts", "ciclo su tutti i prodotti");
            var prod = products[i].product;

            if (products[i].quantity) {
              count = count + 1 * parseInt(products[i].quantity);
            }
            this.$track("checkProducts", "i prodotti inseriti sono : " + count);
          }

          if (count >= parseFloat(this.contests.config.PRODOTTI_MINIMO)) {
            this.$track(
              "checkProducts",
              "ha inserito : " +
                count +
                " su un minimo di " +
                this.contests.config.PRODOTTI_MINIMO
            );
            this.showProdError = false;
          } else {
            this.$track("checkProducts", "Non è ancora arrivato al minimo");
            this.showProdError = true;
          }
        }
      }
    },
    calcTotPrice: async function () {
      await this.takeMyAttempts();
      var prod = this.products;
      var count = 0;
      var qnt = 0;
      for (var x in prod) {
        if (prod[x].price && prod[x].quantity) {
          qnt = qnt + parseFloat(prod[x].quantity);
          count =
            count +
            parseFloat(prod[x].price).toFixed(2) * parseInt(prod[x].quantity);
          this.$track(
            "calcTotPrice",
            "Il prezzo del prodotto selezionato è : " + prod[x].price
          );
          this.$track(
            "calcTotPrice",
            "La quantitá del prodotto selezionato è : " + prod[x].quantity
          );
          this.$track("calcTotPrice", "QNT TOT: " + qnt);
          this.$track("calcTotPrice", "PRICE : " + count);
        }
        if (prod[x].points && prod[x].quantity) {
          qnt = qnt + parseFloat(prod[x].quantity);
          count =
            count +
            parseFloat(prod[x].points) * parseInt(prod[x].quantity);
          this.$track(
            "calcTotPrice",
            "Il punteggio del prodotto selezionato è : " + prod[x].points
          );
          this.$track(
            "calcTotPrice",
            "La quantitá del prodotto selezionato è : " + prod[x].quantity
          );
          this.$track("calcTotPrice", "QNT TOT: " + qnt);
          this.$track("calcTotPrice", "PUNTEGGIO : " + count);
        }
      }
      if (qnt > this.contests.config.PRODOTTI_MASSIMO) {
        this.numMaxQnt_prod = true;
      } else {
        this.numMaxQnt_prod = false;
      }
      if (this.contests.config.DESTINAZIONE_SCONTO == 'PRODOTTO') {
        if (qnt + this.my_registration_in_promo > this.maxRegistration) {
        this.numMaxAttempts_prod = true;
      } else {
        this.numMaxAttempts_prod = false;
      }
      }
      
      if (this.contests.config.RIMBORSO_SECONDO_PRODOTTO) {
        if (qnt == 1)
          this.discount = this.contests.config.RIMBORSO_PRIMO_PRODOTTO;
        if (qnt == 2)
          this.discount = this.contests.config.RIMBORSO_SCONTO_PRODOTTO;
      } else if (this.contests.config.RIMBORSO_COMPLESSIVO) {
        this.discount = this.contests.config.RIMBORSO;
      }
      this.$track(
        "calcTotPrice",
        "Lo sconto che deve essere applicato è : " + parseFloat(this.discount)
      );
      if (isNaN(count)) {
        count = 0;
      }
      this.totPrice = parseFloat(count).toFixed(2);
      //CHECK TOTAL OF RECEIPT
      if (this.contests.config.PREZZO_MINIMO > 0) {
        if (this.totPrice < parseFloat(this.contests.config.PREZZO_MINIMO)) {
          this.minPrice_products = true;
        } else {
          this.minPrice_products = false;
        }
      }
      if (this.contests.config.PREZZO_MASSIMO > 0) {
        if (this.totPrice > parseFloat(this.contests.config.PREZZO_MASSIMO)) {
          this.maxPrice_products = true;
        } else {
          this.maxPrice_products = false;
        }
      }
    },
    takeMyAttempts: async function () {
      this.loadingState = true;
      this.$track("takeMyAttempts", "START");
      var data = {
        id: this.$route.params.id,
        piva: this.$route.params.piva,
        cod: this.$route.params.cod,
        group: this.group,
        desc: this.contests.config.DESTINAZIONE_SCONTO,
        profile: this.profile,
        id_platform: process.env.ID_PLATFORM,
        unique_key_db: process.env.UNIQUE_KEY_DB,
        vector_unique_key_db: process.env.ICODE,
      };
      data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
      await axios({
        method: "POST",
        data: { data },
        url: process.env.ROOT_API + "api/takeMyAttempts",
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          this.loadingState = false;
          this.$track("takeMyAttempts", "SUCCESS");
          resp.data = this.$decryptByAES(resp.data, process.env.CRYPTKEY);
          this.$track("takeMyAttempts -> MY", resp.data);
          this.$track("takeMyAttempts -> MAX", this.maxRegistration);
          this.my_registration_in_promo = resp.data.countMyAttempts;
          if (this.my_registration_in_promo >= this.maxRegistration) {
            this.$track(
              "takeMyAttempts -> RAGGIUNTO MASSIMO",
              this.my_registration_in_promo + " >= " + this.maxRegistration
            );
            this.notRegister = true;
            var _vue = this;
            var text;
            var text =
              '<h5 class="text-center uppercase red">Hai raggiunto il numero massimo di richieste di rimborso disponibili per questa promozione</h5> ';
            text +=
              '<p class="text-center Bold mt-1 pt-5 red">Il numero massimo di richieste di rimborso per questa promozione é <h3 class="bordered back-color-1 white">' +
              this.maxRegistration +
              "</h3></p>";
            var mySwal = this.$swal;
            mySwal({
              html: text,
              showCloseButton: true,
              width: 555,
              color: "red",
              showConfirmButton: false,
              confirmButton: "closeProductsModal",
              confirmButtonClass: "btn btn-secondary",
              onClose: () => {
                this.$router.push(
                  "/contest/" +
                    this.$route.params.id +
                    "/" +
                    this.$route.params.piva +
                    "/" +
                    this.$route.params.cod
                );
              },
            });
          }
        })
        .catch((err) => {
          this.loadingState = false;
          this.$track("takeMyAttempts", "ERROR");
          err.response.data = this.$decryptByAES(
            err.response.data,
            process.env.CRYPTKEY
          );
        });
    },
    showPlay() {
      var _vue = this;
      var text =
        '<h5 class="text-center uppercase">L`inserimento della richiesta di rimborso é andata a buon fine.</h5> ';
      text += '<p class="white"> <br /></p>';
      text += '<p class="white"> <br /></p>';
      text += '<p class="white"> <br /></p>';
      var mySwal = this.$swal;
      mySwal({
        title:
          '<div class="col-12 center d-flex justify-content-center" style="width:700px"><div class="w-25 px-2 px-md-3 line-h4"><hr /></div><h4 class="text-center Bold">ESITO</h4><div class="w-25 px-2 px-md-3 line-h4"><hr /></div></div>',
        html: text,
        showCloseButton: true,
        width: 1000,
        showConfirmButton: false,
        confirmButton: "closeProductsModal",
        confirmButtonClass: "btn btn-secondary",
        onClose: () => {
          if (this.mobileUpl) {
            window.location.reload();
          } else {
            this.$router.push(
              "/contest/" +
                this.$route.params.id +
                "/" +
                this.$route.params.piva +
                "/" +
                this.$route.params.cod
            );
          }
        },
      });
    },
    doAcceptReg(value) {
      this.$store.dispatch(ACCEPT_REG, value).then((resp) => {});
    },
    UploadError(desc, specific) {
      this.$swal({
        type: "error",
        title: desc,
        html: specific,
        confirmButtonText: "CHIUDI",
        confirmButtonColor: "#15267",
        onClose: () => {
          this.$router.push("/");
        },
      });
    },
    getThisContest: async function () {
      this.loadingState = true;
      this.$track("getThisContest", "START");
      var data = {
        id: this.$route.params.id,
        status: "ACTIVE",
        id_platform: process.env.ID_PLATFORM,
        unique_key_db: process.env.UNIQUE_KEY_DB,
        vector_unique_key_db: process.env.ICODE,
      };
      data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
      await axios({
        method: "POST",
        data: { data },
        url: process.env.ROOT_API + "api/getThisContest",
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          this.loadingState = false;
          resp.data = this.$decryptByAES(resp.data, process.env.CRYPTKEY);
          this.$track("getThisContest", "SUCCESS");
          if (resp.data) {
            this.empty = false;
          }
          for (var i in resp.data) {
            var pass = JSON.parse(resp.data[i].config);
            resp.data[i].config = pass;
          }
          this.contests = resp.data[0];

          this.type = this.contests.config.TIPOLOGIA_RIEPILOGO;
          this.start_ = this.contests.start;
          this.start = moment(this.start_).format("DD-MM-YYYY");
          this.end_ = this.contests.end;
          this.end = moment(this.end_).format("DD-MM-YYYY");
          this.theseProducts();
          this.now = moment();
          var then = moment(this.end_);

          var dif = then.diff(this.now);
          if (dif <= 0) {
            this.finish = true;
            this.countdown = 0 - dif;
          } else {
            this.countdown = dif;
          }
          this.$track("getThisContest", this.contests);
        })
        .catch((err) => {
          this.loadingState = false;
          err.response.data = this.$decryptByAES(
            err.response.data,
            process.env.CRYPTKEY
          );
          this.$track("getThisContest", "ERROR");
        });
    },
    theseProducts: async function () {
      this.loadingState = true;
      this.$track("theseProducts", "START");
      var data = {
        id: this.$route.params.id,
        profile: this.profile,
        desc: this.contests.config.DESTINAZIONE_SCONTO,
        id_platform: process.env.ID_PLATFORM,
        unique_key_db: process.env.UNIQUE_KEY_DB,
        vector_unique_key_db: process.env.ICODE,
      };
      data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
      await axios({
        method: "POST",
        data: { data },
        url: process.env.ROOT_API + "api/theseProducts",
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          this.loadingState = false;
          this.$track("theseProducts", "SUCCESS");
          resp.data = this.$decryptByAES(resp.data, process.env.CRYPTKEY);
          this.$track("theseProducts", resp.data);

          this.productList = resp.data;
        })
        .catch((err) => {
          this.$track("theseProducts", "ERROR");
          err.response.data = this.$decryptByAES(
            err.response.data,
            process.env.CRYPTKEY
          );
        });
    },

    setProfileData: function () {
      this.email = this.profile.email;
      this.name = this.profile.ACname;
      this.lastname = this.profile.ACsecondname;
      this.userToken = this.profile.id;
      this.token = this.profile.token;
      this.piva = this.profile.piva;
      this.company = this.profile.company;
      this.phone = this.profile.phone;
      this.role = this.profile.role;
      this.iban = this.profile.iban;
      this.cod = this.profile.cod;
      this.address = this.profile.address;
      this.privacy = this.profile.consent;
      this.group = this.profile.groupPh;
      this.cod_client = this.profile.cod;
      this.profileId = this.profile.id;
    },
    showConfirmReg() {
      var reg = this.accepted_regulations;

      if (reg[this.id]) {
      } else {
        this.$swal({
          type: "info",
          title: "Consenso necessario",
          html:
            '<p class="black">cliccando su conferma si accettano il <a class="link underline" target="_blank" href="' +
            this.regulation +
            '" style="color: blue;"> termini e le condizioni di questa promozione </a>',
          confirmButtonText: "CONFERMA",
          confirmButton: "closeProductsModal",
          onClose: () => {
            this.$store.dispatch(ACCEPT_REG, this.id);
          },
        });
      }
    },
    activateMod: function (param) {
      this.modify = true;
      this.change = false;
      this.pricenew = param;
    },
    deactivateMod: function () {
      var _vue = this;
      this.pricenew = "";
      setTimeout(function () {
        _vue.modify = false;
      }, 100);
    },
    selectChange: function (param) {
      this.change = true;
      this.errProd = false;
    },
    priceMod(param) {
      var _vue = this;
      this.changeSecond = param;
    },
    myRegistration: async function () {
      if (this.piva != this.$route.params.piva) {
      } else {
        this.$track("myRegistration", "START");
        var data = {
          id: this.$route.params.id,
          piva: this.$route.params.piva,
          cod: this.$route.params.cod,
          group: this.group,
          profile: this.profile,
          id_platform: process.env.ID_PLATFORM,
          unique_key_db: process.env.UNIQUE_KEY_DB,
          vector_unique_key_db: process.env.ICODE,
        };
        data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
        await axios({
          method: "POST",
          data: { data },
          url: process.env.ROOT_API + "api/myRegistration",
          headers: {
            Authorization: "Bearer " + process.env.AUTH_TOKEN,
            "Content-type": "application/json",
          },
        })
          .then((resp) => {
            resp.data = this.$decryptByAES(resp.data, process.env.CRYPTKEY);
            this.$track("myRegistration", "SUCCESS");
            this.$track("myRegistration", resp.data);
            if (resp.data) {
              this.maxRegistration =
                parseInt(resp.data[0].bonus) +
                parseInt(resp.data[0].extra_bonus);
              this.maxRegistrationOr = parseInt(resp.data[0].bonus);
            }
          })
          .catch((err) => {
            this.$track("myRegistration", "ERROR");
            err.response.data = this.$decryptByAES(
              err.response.data,
              process.env.CRYPTKEY
            );
          });
      }
    },
    calcToDate() {
      var _vue = this;
      var startRecDate = {
        year: moment(_vue.startRec_).year(),
        month: moment(_vue.startRec_).month(),
        day: moment(_vue.startRec_).day(),
      };
      var start = startRecDate;
      var date = new Date(new Date().setDate(new Date().getDate() - 5));
      var startDate = new Date(start.year, start.month - 1, start.day);
      if (startDate > date) {
        var finalTo = startDate;
      } else {
        var finalTo = startDate;
      }
      return finalTo;
    },
    calcFromDate() {
      var _vue = this;
      var endRecDate = {
        year: moment(_vue.endRec_).year(),
        month: moment(_vue.endRec_).month(),
        day: moment(_vue.endRec_).day(),
      };
      var stopObj = endRecDate;
      var stopDate = new Date(stopObj.year, stopObj.month - 1, stopObj.day + 1);
      var nowDate = new Date();
      if (nowDate <= stopDate) {
        var finalFrom = nowDate;
      } else {
        var finalFrom = stopDate;
      }
      return finalFrom;
    },
    checkAccess: async function () {
      if (this.piva == this.$route.params.piva) {
        this.$track("checkAccess", "START");
        var data = {
          id: this.$route.params.id,
          piva: this.$route.params.piva,
          cod: this.$route.params.cod,
          group: this.group,
          profile: this.profile,
          id_platform: process.env.ID_PLATFORM,
          unique_key_db: process.env.UNIQUE_KEY_DB,
          vector_unique_key_db: process.env.ICODE,
        };
        data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
        await axios({
          method: "POST",
          data: { data },
          url: process.env.ROOT_API + "api/checkAccess",
          headers: {
            Authorization: "Bearer " + process.env.AUTH_TOKEN,
            "Content-type": "application/json",
          },
        })
          .then((resp) => {
            resp.data = this.$decryptByAES(resp.data, process.env.CRYPTKEY);
            this.loadingState = false;
            this.checkAccessOk = true;
            this.$track("checkAccess", "SUCCESS");
            this.$track("checkAccess", resp.data);
            if (resp.data == "access_denied") {
              this.message =
                '<b class="Bold">Non hai accesso a questa promozione</b>';
              this.UploadError("", this.message);
            } else {
            }
          })
          .catch((err) => {
            this.loadingState = false;
            this.$track("checkAccess", "ERROR");
            err.response.data = this.$decryptByAES(
              err.response.data,
              process.env.CRYPTKEY
            );
          });
      } else {
        this.$router.push("/");
      }
    },
  },
  /********************************************************************************************* */
  watch: {
    "$route.params.id": {
      handler: function (id) {
        if (this.loaded) {
        }
      },
      deep: true,
      immediate: true,
    },
    "$route.params.piva": {
      handler: function (id) {
        if (this.loaded) {
        }
      },
      deep: true,
      immediate: true,
    },
    "$route.params.phone": {
      handler: function (id) {
        if (this.loaded) {
        }
      },
      deep: true,
      immediate: true,
    },
    products: {
      handler(val) {
        var _vue = this;
        switch (this.contests.config.DESTINAZIONE_SCONTO) {
          case "PUNTI":
            setTimeout(function () {
              if (_vue.productList[0]) {
                if (_vue.change) {
                  _vue.products[_vue.changeSecond].points = "";
                }
                if (
                  _vue.products[_vue.changeSecond].product &&
                  !_vue.products[_vue.changeSecond].points &&
                  !_vue.modify &&
                  _vue.pricenew == ""
                ) {
                  _vue.products[_vue.changeSecond].points =
                    "" +
                    _vue.productList[0][
                      _vue.products[_vue.changeSecond].product
                    ];
                  _vue.change = false;
                }
              }
              _vue.products[_vue.changeSecond].points = val[
                _vue.changeSecond
              ].points.replace(",", ".");
              _vue.products[_vue.changeSecond].points = val[
                _vue.changeSecond
              ].points.replace(
                /[`~!@#$£%^&*()_|+\-=?;:",<>\{\}\[\]\\\/]/gi,
                ""
              );
            }, 100);
            this.checkProducts();
            this.calcTotPrice();
            break;

          default:
            setTimeout(function () {
              if (_vue.productList[0]) {
                if (_vue.change) {
                  _vue.products[_vue.changeSecond].price = "";
                }
                if (
                  _vue.products[_vue.changeSecond].product &&
                  !_vue.products[_vue.changeSecond].price &&
                  !_vue.modify &&
                  _vue.pricenew == ""
                ) {
                  _vue.products[_vue.changeSecond].price =
                    "" +
                    _vue.productList[0][
                      _vue.products[_vue.changeSecond].product
                    ];
                  _vue.change = false;
                }
              }
              _vue.products[_vue.changeSecond].price = val[
                _vue.changeSecond
              ].price.replace(",", ".");
              _vue.products[_vue.changeSecond].price = val[
                _vue.changeSecond
              ].price.replace(/[`~!@#$£%^&*()_|+\-=?;:",<>\{\}\[\]\\\/]/gi, "");
            }, 100);
            this.checkProducts();
            this.calcTotPrice();
            break;
        }
      },
      deep: true,
    },
    getProfile: function (val) {
      this.setProfileData();
      this.checkAccess();
      this.myRegistration();
      this.loadProducts();
    },
  },
  mounted: function () {
    var id = this.$route.params.id;
    this.id = id;
    var piva = this.$route.params.piva;
    var cod = this.$route.params.cod;
    this.loadProducts();
    if (!piva || !cod) {
      this.$router.push("/");
    }
    this.setProfileData();
    if (this.getProfile.piva) {
      this.setProfileData();
      this.myRegistration();

      var _vue = this;
    }
    if (this.$route.params.phone == 1) {
      this.mobileUpl = true;
    }

    //this.getThisContest()
    var _vue = this;
    //_vue.setProfileData()
    setTimeout(function () {
      _vue.$scrollTo("#top", 0, { offset: -125 });
    }, 100);
  },
  created: async function () {
    await this.getThisContest();
  },
  computed: {
    ...mapGetters([
      "getProfile",
      "isAuthenticated",
      "isProfileLoaded",
      "acceptCookies",
      "accepted_regulations",
    ]),
    ...mapState({
      authLoading: (state) => state.auth.status === "loading",
      profile: (state) => state.user.profile,
    }),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/play/step_2_prodotti.vue